// Single "Name (id)" formatter for every diagnostics card that renders a
// raw Hostaway/Smoobu property id, so an operator can always identify the
// property and copy the id into another card (e.g. the Dedup Pair Probe).
// An unresolved id renders visibly as "unknown (id)", never dropped.
export function formatPropertyLabel(name, id) {
  return `${name || 'unknown'} (${id})`;
}
